/* ============ 新手礼包倒计时（24 小时） ============ */
var now = Date.now();
var deadline = 0;

try {
    deadline = Number(window.localStorage.getItem('mobieark_gift_deadline')) || 0;
} catch (error) {
    deadline = 0;
}

if (deadline < now) {
    deadline = now + 24 * 60 * 60 * 1000;

    try {
        window.localStorage.setItem('mobieark_gift_deadline', deadline);
    } catch (error) { }
}

// 数字补零，保证倒计时显示为两位
var pad = function (num) {
    return num < 10 ? '0' + num : '' + num;
};

var countdown = function () {
    var left = Math.max(0, deadline - Date.now());

    $('.countdown .time').text(
        pad(Math.floor(left / 3600000)) + ' : ' +
        pad(Math.floor(left % 3600000 / 60000)) + ' : ' +
        pad(Math.floor(left % 60000 / 1000))
    );
};

countdown();
setInterval(countdown, 1000);
